'use strict';
import template from './generarListas.html';
import controller from './generarListas.controller';

const GenerarListasComponent = {
  controller,
  template
};

export default GenerarListasComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/generar_listas/generarListas.component.js